import React from "react";

const PhoneInput = ({
  countryCode,
  onCountryCodeChange,
  phoneNumber,
  onPhoneNumberChange,
  placeholder = "Phone number",
  label = "Phone",
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-[#00191A] mb-2">
        {label}
      </label>
      <div className="flex rounded-xl bg-white border border-[#E1E1E1] focus-within:border-[#14C5D1] overflow-hidden">
        <select
          value={countryCode}
          onChange={onCountryCodeChange}
          className="px-4 py-2 bg-transparent border-0 focus:outline-none text-[#00191A]"
        >
          <option value="+1">US (+1)</option>
          <option value="+44">UK (+44)</option>
          <option value="+49">DE (+49)</option>
        </select>
        <input
          type="tel"
          value={phoneNumber}
          onChange={onPhoneNumberChange}
          placeholder={placeholder}
          className="flex-1 px-4 py-2 bg-transparent border-0 focus:outline-none text-[#00191A]"
        />
      </div>
    </div>
  );
};

export default PhoneInput;

